import React from 'react';

import { styled } from 'styled-components';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

const PrefixText = styled.span`
  color: rgba(0, 0, 0, 0.6);
`;

const ValueText = styled.span`
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
`;

const ArrowIcon = styled.span`
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.54);
`;

interface FilterButtonProps {
  prefix: string;
  value?: string;
  children?: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isOpen?: boolean;
  testId?: string;
}

const FilterButton = ({
  prefix,
  value,
  children,
  onClick,
  isOpen = false,
  testId,
}: FilterButtonProps): React.ReactElement => (
  <StyledButton onClick={onClick} data-testid={testId}>
    <PrefixText>{prefix}</PrefixText>
    {value && <ValueText>{value}</ValueText>}
    {children}
    <ArrowIcon>{isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</ArrowIcon>
  </StyledButton>
);

export default FilterButton;
